import BenefitsFeatures from './BenefitsFeatures';

export default BenefitsFeatures;
